import {
  Box,
  Button,
  IconButton,
  Typography,
  Checkbox,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { useEffect, useState } from 'react';
import { window_open } from 'src/utils/flutter';
import { useAnalytics } from 'use-analytics';

interface Props {
  open: boolean;
  handleClose: () => void;
  inspections: any;
  vehicle: any;
}

const PrintModal: React.FC<Props> = ({
  open,
  handleClose,
  inspections,
  vehicle,
}) => {
  const { track } = useAnalytics();
  const theme = useTheme();
  const smBelow = useMediaQuery(theme.breakpoints.down('sm'));

  const [printOptions, setPrintOptions] = useState([] as any);

  useEffect(() => {
    const options = [
      {
        id: null,
        key: 'details',
        title: 'Vehicle Details',
        checked: false,
      },
      {
        id: null,
        key: 'window-sticker',
        title: 'Window Sticker',
        checked: false,
      },
      {
        id: null,
        key: 'transportation',
        title: 'Transportation',
        checked: false,
      },
    ] as any;

    if (inspections && inspections.length) {
      options.push({
        id: null,
        key: 'certificate',
        title: 'Checklist Certificate',
        checked: false,
      });
    }

    inspections
      ? inspections.map((inspection: any) => {
          options.push({
            key: null,
            id: inspection.id,
            title: inspection.inspection_template.title ?? '',
            checked: false,
          });
        })
      : null;

    setPrintOptions(options);
  }, [inspections]);

  const onChecked = (index: number) => {
    const itemRef = [...printOptions];

    itemRef[index].checked = !itemRef[index].checked;

    setPrintOptions([...itemRef]);
  };

  const onSavedClick = () => {
    const pages = printOptions
      .filter((option: any) => option.key)
      .filter((option: any) => option.checked)
      .map((option: any) => option.key)
      .join(',');
    const inspectionIds = printOptions
      .filter((option: any) => option.id)
      .filter((option: any) => option.checked)
      .map((option: any) => option.id)
      .join(',');
    track(
      'print-modal-print',
      {
        pages,
        inspectionIds,
        vehicleId: vehicle.id,
        vin: vehicle.vin,
      },
      {
        component: 'sales-packet',
        custom: { vin: vehicle.vin },
      }
    );
    if (window.location.hostname === 'staging-next.carketa.app') {
      window_open(
        `https://us-central1-carketa-prod.cloudfunctions.net/production-sales-packet-pdf-v2?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    } else if (window.location.hostname === 'localhost') {
      window_open(
        `http://localhost:8080?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    } else {
      window_open(
        `https://us-central1-carketa-prod.cloudfunctions.net/production-sales-packet-pdf-1?id=${vehicle.id}&vin=${vehicle.vin}&pages=${pages}&inspectionIds=${inspectionIds}`,
        '_blank',
        'noreferrer'
      );
    }
  };

  return (
    <Dialog open={open} onClose={() => handleClose()} fullScreen={smBelow}>
      <DialogTitle>
        Print Options
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'start',
            flexDirection: 'column',
            p: 2,
            minWidth: '380px',
            minHeight: '200px',
          }}
        >
          {printOptions
            ? printOptions.map((option: any, index: number) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Checkbox
                      checked={option.checked}
                      onClick={() => onChecked(index)}
                    />
                    <Typography> {option.title} </Typography>
                  </Box>
                );
              })
            : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{
              backgroundColor: '#FF4C51 !important',
              '&:hover': {
                backgroundColor: '#FF4C51 !important',
                color: '#FFF',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onSavedClick}
            sx={{
              backgroundColor: '#56ca00 !important',
              '&:hover': {
                backgroundColor: '#56ca00 !important',
                color: '#FFF',
              },
            }}
          >
            Print
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
};

export default PrintModal;
